import React, { useState } from 'react';
import DateTimePicker from 'react-datetime-picker';

function Time() {
  const [value, onChange] = useState(new Date());

  return (
    <div>
      <DateTimePicker format='y-MM-dd'  onChange={onChange} value={value} />

      <DateTimePicker format='h:mm:a' disableCalendar='true' amPmAriaLabel onChange={onChange} value={value} />
    </div>
  );
}
export default Time;